var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09327 0.625L18.1865 16.375H0L9.09327 0.625Z",
    fill: "#BC2525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowDanger);
export default __webpack_public_path__ + "static/media/up-arrow-danger.2eea7bfd3d6c726725cf0fd151a891ba.svg";
export { ForwardRef as ReactComponent };